import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
// import "antd/dist/antd.css";
import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { TableContext } from "./context/TableContent";
import { UserContext } from "./context/UserContext";
import "./axios/index.js";
import "./index.css";
import RoutesPage from "./Routes";
import store from "./store";
import { theme } from "./utils/Themes";


const App = () => {
  const [tableRows, setTableRows] = React.useState([]);
  const [user, setUser] = React.useState({});
  const [company, setCompany] = React.useState({});

  
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <TableContext.Provider
            value={{
              rows: tableRows,
              setRows: setTableRows,
            }}
          >
            <UserContext.Provider
              value={{
                user,
                setUser,
                company,
                setCompany,
              }}
            >
              <RoutesPage />
            </UserContext.Provider>
          </TableContext.Provider>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// ReactDOM.render(<App />, document.getElementById("root"));
